import * as ng from 'angular';
import { ContractService } from '../../../services/contract.service';
import { ArchiSmallServices } from '../../../services/archismall.service';

class SignContractModalController implements ng.IController {

    static $inject: string[] = [
        '$scope',
        '$rootScope',
        'ContractService',
        'store',
        'ArchiSmallServices',
        '$state'
    ];

    private close: any;

    private phoneType: any;
    private invalidCode: any;
    private isEmpty: any;
    private controlsDisabled: any;
    private messageSent: any;
    private showLoading: any;
    private phone: any;
    private checkboxOptions: any;
    private user: any;
    private buttonDisabled: any;
    private isSigning: any;
    private signUserProfileId: any;
    private contractPath: any;
    private code: any;

    constructor(
        private $scope: any,
        private $rootScope: any,
        private _contractService: ContractService,
        private store: ng.a0.storage.IStoreService,
        private ArchiSmallServices: ArchiSmallServices,
        private $state: any, // ng.IRootScopeService
    ) {
        $rootScope.formsubmitted = false;

        let vm = this;

        $scope.phoneType = new RegExp('^[\u0000-\u007F]{5,12}$');
        $scope.invalidCode = false;
        $scope.isEmpty = false;
        $scope.controlsDisabled = true;
        $scope.messageSent = false;
        $scope.showLoading = false;

        vm.user = store.get('registeringUser');
        $scope.phone = vm.user.organizationData.phoneNumber;

        $scope.checkboxOptions = {
            'contrattoFornitura': {
                'label': 'CONTRATTO PER LA FORNITURA DI SERVIZI INFORMATICI DI GESTIONE DOCUMENTALE E CONSERVAZIONE',
                'link': 'https://www.archismall.com/contratto-per-la-fornitura-di-servizi-informatici-di-gestione-documentale-e-conservazione',
                'checked': false
            },
            'allegatoA': {
                'label': 'Allegato A - Nomina del Responsabile del Trattamento',
                'link': 'https://www.archismall.com/allegato-a-nomina-del-responsabile-del-trattamento',
                'checked': false
            },
            'allegatoB': {
                'label': 'Allegato B - Delega all\'Emissione dei file Fattura Pa_Pr',
                'link': 'https://www.archismall.com/allegato-b-delega-all-emissione-dei-file-fattura-pa-pr',
                'checked': false
            },
            'allegatoC': {
                'label': 'Allegato C - Informativa sulla firma elettronica avanzata del contratto',
                'link': 'https://www.archismall.com/allegato-c-informativa-sulla-firma-elettronica-avanzata-dei-contratti',
                'checked': false
            },
            'allegatoD': {
                'label': 'Allegato D - Informativa sul trattamento dei dati personali',
                'link': 'https://www.archismall.com/allegato-d-informativa-sul-trattamento-dei-dati-personali',
                'checked': false
            }
        };

        $scope.inviaSMS = () => {
            let vm = this;
            if (typeof $scope.phone === 'undefined' || $scope.phone === '') {
                $scope.isEmpty = true;
                return;
            }

            $scope.controlsDisabled = true;
            $scope.buttonDisabled = true;
            $scope.showLoading = true;

            let data = {
                'user': vm.user,
                'phoneNumber': $scope.phone
            };

            vm._contractService.sendOTP(data)
                .then((response) => {
                    $scope.showLoading = false;
                    $scope.messageSent = true;
                    vm.signUserProfileId = response;
                    $scope.controlsDisabled = false;
                    //                                vm.buttonDisabled = false;
                }, (error) => {
                    vm.$rootScope.alert('error', error.data && error.data.errorDetails ? error.data.errorDetails : error);
                    $scope.controlsDisabled = false;
                    //                                vm.buttonDisabled = false;
                    $scope.showLoading = false;
                });
        };


        $scope.reinitializeIsEmpty = () => {
            let vm = this;
            $scope.isEmpty = false;
        };


        $scope.registerUser = (user: any) => {
            let vm = this;
            vm.ArchiSmallServices.registerUser(user)
                .then((response: any) => {
                    vm.store.set('registeredUser', response);
                    vm.store.remove('registeringUser');

                    vm.close();
                    vm.$state.go('registration.summary');
                }, (error) => {
                    //                                vm.buttonDisabled = false;
                    $scope.controlsDisabled = false;
                    $scope.isSigning = false;
                    vm.$rootScope.alert('error', error.data.errorDescription);
                });
        };

        $scope.signContract = () => {
            let vm = this;
            if (typeof vm.signUserProfileId === 'undefined' || vm.signUserProfileId === '') {
                return;
            }

            let data = {
                'user': vm.user,
                'signUserProfileId': vm.signUserProfileId,
                'otp': $scope.code
            };

            //                    vm.buttonDisabled = true;
            $scope.controlsDisabled = true;
            $scope.isSigning = true;

            vm._contractService.signContract(data)
                .then((response) => {
                    vm.$rootScope.generateGoogleAPIToken();
                    vm.contractPath = response;
                    vm.user.organizationData.contactPerson.contractFileId = vm.contractPath;

                    this.$scope.registerUser(vm.user);
                }, (error) => {
                    $scope.controlsDisabled = false;
                    $scope.isSigning = false;


                    if (error.errorCode === vm.$rootScope.ArchiSmallERRORS.REMOTE_SIGNATURE_OTP_INCORRECT) {
                        vm.$rootScope.alert('warning', 'Il codice SMS che hai inserito non è valido. <br/>' +
                            'Inseriscilo nuovamente oppure richiedine uno nuovo selezionando \'Reinvia SMS\'.');
                    } else {
                        vm.$rootScope.alert('error', error);
                    }
                });
        };

        $scope.isCheckboxUnchecked = () => {
            let vm = this;
            for (let key in $scope.checkboxOptions) {
                if ($scope.checkboxOptions[key].checked === false || $scope.checkboxOptions[key].checked === undefined) {
                    $scope.controlsDisabled = true;
                    return;
                }
            }
            $scope.controlsDisabled = false;
        };
    }

}

export const SignContractModalComponent: ng.IComponentOptions = {
    template: require('./sign-contract-modal.html'),
    controller: SignContractModalController,
    bindings: {
        close: '&'
    }
};




// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/registration/sign-contract-modal/sign-contract-modal.ts